<template>
    <modal name="update_booking_disabled_date" height="auto" scrollable adaptive @before-open="beforeOpen">
        <app-card :title="$t('Update locked date in booking')">
            <validation-observer v-slot="{ validate }" slim>
                <form @submit.prevent="update(validate)">
                    <app-datepicker v-model="form.date">
                        <template #label>
                            {{ $t('Date') }}
                        </template>
                    </app-datepicker>
                    <div class="form-group row">
                        <div class="col-md-7 offset-md-3 d-flex">
                            <app-button :loading="loading">
                                {{ $t('Update') }}
                            </app-button>
                            <app-button class="ml-2" type="outline-warning" native-type="button" @click="hide">
                                {{ $t('Cancel') }}
                            </app-button>
                        </div>
                    </div>
                </form>
            </validation-observer>
        </app-card>
    </modal>
</template>

<script>
import BookingDisabledDateService from '@services/bookingLockedDate.service';
import moment from 'moment';

export default {
    data() {
        return {
            form: {},
            loading: false,
            date_id: null
        };
    },
    methods: {
        update(validate) {
            validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    BookingDisabledDateService.update(this.date_id, this.form).then(res => {
                        this.$toastr.s(this.$t('Updated'));
                        this.loading = false;
                        this.hide();
                        this.$emit('setDate', res);
                    });
                }
            });
        },
        beforeOpen(event) {
            const date = event.params.date;
            if (date) {
                this.date_id = date.id;
                this.form.date = moment(date.date).format('L');
            }
        },
        hide() {
            this.$modal.hide('update_booking_disabled_date');
        }
    }
};
</script>
